import { useState } from "react";
import { CrisisMode } from "./app/CrisisMode";
export function PublicSupport() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button className="btn btn-ghost" onClick={() => setOpen(true)}>
        Find support
      </button>
      <CrisisMode isActive={open} onExit={() => setOpen(false)} manual />
    </>
  );
}
